import * as React from 'react';
import {useLoaderData, useNavigate} from "react-router-dom";
import logo from '../assets/logo.jpg'
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

export default function Play() {
    const navigate = useNavigate()
    const game = useLoaderData();

    return (
        <>
            <Typography variant={'h3'} color="text.primary">
                Le jeu a commencé !
            </Typography>
            <Typography color="text.primary">
                Bonne chance à toute l'équipe.
            </Typography>
            <img src={logo} alt={'logo'} width={400}/>
            <Button
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                onClick={() => navigate('/games/' + game.id + "/debriefing")}
            >
                Terminer la partie
            </Button>
        </>
    );
}
